<template>
    <div class="fx-g1 fx-col" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="item_block fx fx-m_between info_row ">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="是否分享">
                    <el-select v-model="form.sharing" clearable placeholder="是否分享">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" size="medium" @click="editLesson({})">添加课程</el-button>
            </div>
        </div>
        <div class="panel_body">
            <div v-for="lesson in lessons" :key="lesson.id" class="item_block">
                <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">
                    <div class="coverimg">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="lesson.coverImg"
                            :lazy="true"
                            :preview-src-list="[lesson.coverImg]"
                            fit="fill"></el-image>
                    </div>

                    <div style="width: 380px;">
                        <div class="lesson_name">
                            {{ lesson.name }}
                            <span v-if="lesson.sharing" style="margin-left:10px;">
                                <el-tag
                                    type=""
                                    effect="plain">
                                    已分享至备课共享
                                </el-tag>
                            </span>
                            <span v-if="lesson.teachingMaterialId > 0" style="margin-left:10px;">
                                <el-tag
                                    type="success"
                                    effect="plain">
                                    已分享至教材备课
                                </el-tag>
                            </span>
                            <!-- <span>
                                分享：<el-switch v-model="lesson.sharing"
                                       @change="modifySharing(lesson)"
                                       inactive-color="#ff4949">
                                 </el-switch>
                            </span> -->
                        </div>
                        <div class="fx fx-m_between fx-c_center lesson_resource" style="margin-top: 12px">
                            <span class="fx fx-c_center">视频:
                                <span v-if="lesson.videos.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else type="primary" @click="setShowResources(lesson.videos)"
                                         :underline="false" class="font12"><i
                                    class="iconfont icon-shipin"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">教案:
                                <span v-if="lesson.plans.length==0" class="text_info tip"> 未设置</span>
                                        <el-link v-else type="primary" @click="setShowResources(lesson.plans)"
                                                 :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">PPT:
                                <span v-if="lesson.ppts.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else type="primary" @click="setShowResources(lesson.ppts)" :underline="false"
                                         class="font12"><i class="iconfont icon-ppt"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">代码:
                                <span v-if="lesson.codes.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else type="primary" @click="viewCode(lesson.type, lesson.codes[0].id)"
                                         :underline="false" class="font12"><i
                                    class="iconfont icon-word"></i>查看</el-link>
                            </span>
                        </div>
                        <div style="margin-top: 12px">
                            <tag-group :tags="lesson.tagArray" size="mini"
                                       style="justify-content: flex-start"></tag-group>
                        </div>
                    </div>

                    <div class="fx-g1">{{ lesson.introduction }}</div>
                    <div>
                        <div class="lesson_name fx fx-m_between fx-c_center">
                            <el-button @click="sharingLesson(lesson)" type="primary"
                                       style="border-radius: 10px;margin-left: 85px;position: relative;top: -25px;">
                                分享
                            </el-button>
                            <!--<el-button @click="modifySharing(lesson)" :type="lesson.sharing ? 'info' : 'primary'" style="border-radius: 10px;margin-left: 55px;position: relative;top: -25px;">
                                {{lesson.sharing ? '取消分享':'分享备课'}}
                            </el-button>
                            <el-button @click="modifyTeachingMaterial(lesson)" :type="lesson.teachingMaterialId > 0 ? 'info' : 'primary'" style="border-radius: 10px;position: relative;top: -25px;">
                                {{lesson.teachingMaterialId > 0 ? '取消分享至教材备课':'分享至教材备课'}}
                            </el-button> -->
                        </div>
                        <div style="width: 160px;" class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="editLesson(lesson)"
                                     :underline="false"><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <el-popconfirm @onConfirm="delLesson(lesson)"
                                           title="确认删除该课程吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false"><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
                <div class="fx fx-m_between fx-c_center font16"
                     style="padding: 15px 0; border-bottom: 1px solid var(--border)">
                    <span>课程任务</span>
                    <div>
                        <el-link type="primary" :underline="false" @click="editTask({}, lesson)"><i
                            class="el-icon-circle-plus"></i><b> 添加</b></el-link>
                        <el-link type="primary" :underline="false" @click="openTask(lesson.id)"><i
                            class="el-icon-circle-plus"></i><b> 选择任务</b></el-link>
                    </div>
                </div>

                <div style="padding: 15px 0">
                    <div v-for="(task,i) in lesson.tasks" :key="task.id" class="fx fx-c_center info_row task_item"
                         style="margin-bottom: 6px">
                        <div style="width: 200px">任务{{ i + 1 }}：{{ task.title }}</div>
                        <div class="fx-g1 task fx fx-m_start fx-c_center task_info">
                            <span class="fx fx-c_center">讲解视频:
                                <span v-if="task.videos.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else @click="setShowResources(task.videos)" type="warning" :underline="false"
                                         class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">随堂资料:
                                <span v-if="task.attachments.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else @click="setShowResources(task.attachments)" type="warning"
                                         :underline="false" class="font12"><i
                                    class="iconfont icon-word"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">任务卡片:
                                <span v-if="task.tutorials.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else @click="setShowResources(task.tutorials)" type="warning"
                                         :underline="false" class="font12"><i
                                    class="iconfont icon-ppt"></i>查看</el-link>
                            </span>
                            <span class="fx fx-c_center">相关代码:
                                <span v-if="task.codes.length==0" class="text_info tip"> 未设置</span>
                                <el-link v-else @click="viewCode(lesson.type, task.codes[0].id)" type="warning"
                                         :underline="false" class="font12"><i
                                    class="iconfont icon-word"></i>查看</el-link>
                            </span>
                        </div>
                        <div style="">
                            <el-link type="primary" @click="editTask(task, lesson)"
                                     :underline="false"><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <el-popconfirm @onConfirm="delTask(task, lesson)"
                                           title="确认删除该任务吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false"><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="showBox1"
            width="30%"
            :before-close="close"
        >
            <div class="panel form">
                <el-form ref="form1" :model="form1" label-width="150px" class="edit_form">
                    <el-form-item label="教材">
                        <el-select v-model="form1.teachingMaterialId" placeholder="请选择教材" @change="getContent()">
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="请选择教材课程">
                        <el-select v-model="form1.teachingMaterialContentId" placeholder="请选择教材课程">
                            <el-option
                                v-for="item in options1"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer fx fx-center">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </el-dialog>
        <template>
            <el-dialog title="选择添加的任务" :visible.sync="dialogTableVisible" center width="60%"
                       style="margin-top: -11vh;" class="task_dialog">
                <div class="">
                    <el-form :inline="true" :model="taskForm">
                        <div class="block">
                            <el-select v-model="taskForm.checkType" placeholder="选项" @change="changeOptions">
                                <el-option label="平台" :value="true"></el-option>
                                <el-option label="学校" :value="false"></el-option>
                            </el-select>
                            <el-cascader placeholder="任务知识点筛选"
                                         v-model="taskForm.knowledgeIds"
                                         :options="options2"
                                         :props="{expandTrigger: 'hover'}"
                                         @change="handleChange"
                                         style="width: 300px;margin-left: 20px;" clearable
                            >

                            </el-cascader>
                            <el-form-item label="" style="margin-left: 20px">
                                <el-input v-model="taskForm.keywords" placeholder="请输入任务关键词"
                                          class="keyword_input" style="width: 300px;">
                                    <i slot="suffix" class="el-input__icon el-icon-search font22 text_primary"></i>
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <el-table :data="taskData" style="height:500px;overflow-y:visible" @selection-change="handleChoose"
                          ref="libTable">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column property="date" label="任务" min-width="150">
                        <template slot-scope="scope">
                            {{ scope.row.title }}
                        </template>
                    </el-table-column>
                    <el-table-column property="date" label="知识点" min-width="250">
                        <template slot-scope="scope">
                            <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                        </template>
                    </el-table-column>

                    <el-table-column
                        width="500"
                        label="资料">
                        <template slot-scope="scope">
                            <div class="grid col-4 hgap-5">
                                <div class="fx fx-c_center" v-if="scope.row.videos.length > 0">
                                    讲解视频：
                                    <el-button type="text" @click="setShowResources(scope.row.videos)" size="medium"
                                               class="text_warn">查看
                                    </el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.attachments.length > 0">
                                    随堂资料：
                                    <el-button type="text" @click="setShowResources(scope.row.attachments)"
                                               size="medium" class="text_warn">查看
                                    </el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.codes.length > 0">
                                    代码：
                                    <el-button type="text" @click="viewCode(scope.row.codes[0].id)" size="medium"
                                               class="text_warn">查看
                                    </el-button>
                                </div>
                                <div class="fx fx-c_center" v-if="scope.row.tutorials.length > 0">
                                    卡片：
                                    <el-button type="text" @click="setShowResources(scope.row.tutorials)" size="medium"
                                               class="text_warn">查看
                                    </el-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="panel_foot fx fx-m_end fx-c_center">
                    <el-pagination
                        :background="true"
                        prev-text="上一页"
                        next-text="下一页"
                        layout="prev, pager, next"
                        :current-page="pager1.currentPage"
                        :page-size="pager1.pageSize"
                        :total="pager1.dataTotal"
                        @current-change="pageChange1"
                    >
                    </el-pagination>
                </div>
                <span slot="footer" class="dialog-footer fx fx-center">
                        <el-button type="primary" @click="subAdd()">确认添加</el-button>
                    </span>
            </el-dialog>
        </template>
        <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>

        <TaskEdit v-if="showTaskEdit" @submit="loadTasks"
                  @close="showTaskEdit=false" :item="currentTask"></TaskEdit>
        <LessonEditDrawer v-if="showLessonEdit" @submit="loadLesson"
                          @close="showLessonEdit=false" :item="currentLesson"></LessonEditDrawer>
        <SharingDrawer v-if="showSharing" @submit="loadLesson"
                       @close="closeSharing" :item="currentSharing"></SharingDrawer>
    </div>
</template>
<style scoped>
.panel_foot {
    background-color: white;
}

.tip {
    padding: 0 6px 0 12px;
}

.item_block {
    background: white;
    padding: 18px 50px;
    border-radius: 6px;
    margin-bottom: 10px;
}

.info_row > *:not(:first-child) {
    margin-left: 50px;
}

.coverimg {
    width: 160px;
}

.lesson_name {
    font-size: 16px;
    font-weight: bold;
    color: var(--dark);
}

.lesson_resource i.iconfont, .task_info i.iconfont {
    vertical-align: text-bottom;
}

.task_item {
    height: 50px;
    border-bottom: 1px solid var(--border);
}
</style>
<style>

</style>

<script>
import ResourceDrawer from '@/components/ResourceDrawer';
import VideoDrawer from '@/components/VideoDrawer';
import TaskEdit from "./TaskEdit";
import LessonEditDrawer from "./LessonEditDrawer";
import SharingDrawer from "./SharingDrawer";

export default {
    components: {
        ResourceDrawer,
        VideoDrawer,
        TaskEdit,
        LessonEditDrawer,
        SharingDrawer
    },
    props: [],
    data() {
        return {
            showBox1: false,
            loading: true,
            showResources: false,
            currentResources: [],

            showVideo: false,
            currentVideo: null,

            showTaskEdit: false,
            currentTask: {},

            showEdit: false,
            showLessonEdit: false,
            currentLesson: {},

            showSharing: false,
            currentSharing: {},
            form: {keywords: ''},
            form1: {teachingMaterialId: '', teachingMaterialContentId: ''},
            lessons: [],
            options: [],
            options1: [],
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            currentLessonId: 0,
            taskForm: {
                keywords: "",
                knowledgeIds: [],
                checkType: true,
                type: 0
            },
            dialogTableVisible: false,
            taskData: [],
            options2: [],
            pager1: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
        }

    },

    watch: {
        "form": {
            handler: function () {
                //查询条件变了
                this.loadLessons();
            },
            deep: true
        },
        "taskForm": {
            handler: function (newValue) {
                this.pager.currentPage = 1;
                if (this.taskForm.checkType) {
                    this.loadTaskData()
                } else {
                    this.loadSchoolTaskData();
                }
            },
            deep: true
        },
    },

    methods: {
        openTask(lessonId) {
            this.currentLessonId = lessonId;
            this.taskForm.keywords = "";
            this.dialogTableVisible = true;
            this.taskForm.checkType = true;//添加任务 默认平台
            this.taskForm.type = 1;
            //this.loadTaskData();
        },
        subAdd() {
            let modules = this.choosedList.map(item => {
                return {
                    id: item.id,
                    title: item.title,
                    type: item.type,
                    knowledgeIds: item.knowledgeIds,
                    state: 3,
                    resources: item.resources,
                }
            })
            this.$ajaxPost("/lessonTask/addLessonTasksByBatch", {
                list: modules,
                lessonId: this.currentLessonId,
                checkType: this.taskForm.checkType
            }, (data) => {
                this.$showSuccess("添加成功");
                this.loadTasks([this.currentLessonId]);
                this.dialogTableVisible = false;
                this.$emit("close");
            })
        },
        changeOptions() {
            this.taskData = [];
            this.pager = {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            };
            if (this.taskForm.checkType) {
                this.loadTaskData()
            } else {
                this.loadSchoolTaskData();
            }
        },
        //加载单节课
        loadLesson(lesson) {
            lesson.videos = lesson.resources.filter(r => r.category == 1);
            lesson.plans = lesson.resources.filter(r => r.category == 2);
            lesson.ppts = lesson.resources.filter(r => r.category == 3);
            lesson.codes = lesson.resources.filter(r => r.category == 4);
            lesson.tasks = [];
            let index = -1;

            this.lessons.forEach((item, i) => {
                if (item.id == lesson.id) {
                    index = i;
                    lesson.tasks = item.tasks;
                    return;
                }
            })
            if (index == -1) {
                this.lessons.push(lesson);
            } else {
                this.$set(this.lessons, index, lesson);
            }
            this.showLessonEdit = false;
        },
        //加载所有课
        loadLessons() {
            this.$ajaxPost("/lesson/listByPrepare", {form: this.form, pager: {...this.pager, dataTotal: 0}}, (data) => {
                let lessons = data.result;
                let {offset, ...pager} = data.pager;
                this.pager = pager;
                lessons.forEach(item => {
                    item.videos = item.resources.filter(r => r.category == 1);
                    item.plans = item.resources.filter(r => r.category == 2);
                    item.ppts = item.resources.filter(r => r.category == 3);
                    item.codes = item.resources.filter(r => r.category == 4);
                    item.tasks = null;
                })
                this.lessons = lessons;
                if (lessons.length == 0) {
                    this.loading = false;
                } else {
                    this.loadTasks(lessons.map(item => item.id));
                }

            })
        },
        pageChange(page) {
            this.pager.currentPage = page;
            this.loadLessons();
        },
        pageChange1(page) {
            this.pager1.currentPage = page;
            if (this.taskForm.checkType) {
                this.loadTaskData()
            } else {
                this.loadSchoolTaskData();
            }
        },
        loadTaskData() {
            if (this.dialogTableVisible == false) {
                return;
            }
            this.loadFuncs();
            this.$ajaxPost("/lessonTask/listByPlatFormId", {
                form: this.taskForm,
                pager: {...this.pager1, dataTotal: 0}
            }, (data) => {
                let {offset, ...pager} = data.pager;
                this.pager1 = pager;
                let items = data.result;
                items.forEach(item => {
                    item.videos = item.resources.filter(r => r.category == 1);
                    item.attachments = item.resources.filter(r => r.category == 2);
                    item.codes = item.resources.filter(r => r.category == 3);
                    item.tutorials = item.resources.filter(r => r.category == 4);
                })
                this.taskData = items;
            })
        },
        loadSchoolTaskData() {
            if (this.dialogTableVisible == false) {
                return;
            }
            this.loadFuncs();
            this.taskForm.lessonId = this.currentLessonId;
            this.$ajaxPost("/lessonTask/listByNotTaskId", {
                form: this.taskForm,
                pager: {...this.pager1, dataTotal: 0}
            }, (data) => {
                let {offset, ...pager} = data.pager;
                this.pager1 = pager;
                let items = data.result;
                items.forEach(item => {
                    item.videos = item.resources.filter(r => r.category == 1);
                    item.attachments = item.resources.filter(r => r.category == 2);
                    item.codes = item.resources.filter(r => r.category == 3);
                    item.tutorials = item.resources.filter(r => r.category == 4);
                })
                this.taskData = items;
            })
        },
        handleChoose(val) {
            this.choosedList = val;
        },
        handleChange(value) {
            console.log(value);
        },
        loadTasks(lessonIds) {
            this.$ajaxPost("/lessonTask/listByLessons", {
                lessonIds: lessonIds
            }, (data) => {
                data.result.forEach(item => {
                    item.videos = item.resources ? item.resources.filter(i => i.category == 1) : [],
                        item.codes = item.resources ? item.resources.filter(i => i.category == 3) : [],
                        item.tutorials = item.resources ? item.resources.filter(i => i.category == 4) : [],
                        item.attachments = item.resources ? item.resources.filter(i => i.category == 2) : []
                })
                this.lessons.forEach(item => {
                    if (lessonIds.some(id => id == item.id)) {
                        item.tasks = data.result.filter(task => task.lessonId == item.id);
                    }
                })
                this.loading = false;
                this.showTaskEdit = false;
            })
        },
        editTask(item, lesson) {
            this.currentTask = {...item, type: lesson.type, lessonId: lesson.id};
            this.showTaskEdit = true;
        },
        delTask(task, lesson) {
            this.$ajaxGet("/lessonTaskLink/del/" + task.lessonTaskLinkId, (data) => {
                lesson.tasks = lesson.tasks.filter(item => item != task);
            })
            this.$ajaxGet("/lessonTask/del/" + task.id, (data) => {
                //lesson.tasks = lesson.tasks.filter(item => item != task);
            })
        },
        editLesson(item) {
            this.currentLesson = {...item, lessonSystemId: ''};
            this.showLessonEdit = true;
        },
        delLesson(lesson) {
            this.$ajaxGet("/lesson/del/" + lesson.id, (data) => {
                this.lessons = this.lessons.filter(item => item != lesson);
            })
        },
        sharingLesson(item) {
            this.showSharing = true;
            this.currentSharing = item;
        },
        modifySharing(item) {
            this.$ajaxGet("/lesson/toggleSharing/" + item.id + "-" + !item.sharing);
            let lesson = this.lessons.filter(lesson => lesson.id == item.id);
            lesson[0].sharing = !lesson[0].sharing;
        },
        modifyTeachingMaterial(lesson) {
            this.form1.teachingMaterialId = '';
            this.form1.teachingMaterialContentId = '';
            this.currentLesson = lesson;
            if (lesson.teachingMaterialId > 0) {
                this.$confirm('确定取消分享吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form1.teachingMaterialId = 0;
                    this.form1.teachingMaterialContentId = 0;
                    this.sub();
                }).catch(() => {
                });
                return;
            }
            this.showBox1 = true;
        },
        sub() {
            this.$ajaxGet("/lesson/doTeachingMaterial/" + this.currentLesson.id + "-" + this.form1.teachingMaterialContentId, (data) => {
                this.$showSuccess("操作成功");
                this.loadLessons();
                this.showBox1 = false;
            })
        },
        close() {
            this.showBox1 = false;
        },
        setShowResources(resources) {
            this.currentResources = resources;
            this.showResources = true;
        },

        play(url) {
            this.currentVideo = url;
            this.showVideo = true;
        },
        viewCode(lessonType, id) {
            this.$goEditCode(lessonType, `mode=caseview&id=${id}`);
        },
        loadTeachingMaterial() {
            this.$ajaxGet("/teachingMaterial/listOption", (data) => {
                this.options = data.result;
            })
        },
        getContent() {
            this.$ajaxGet("/teachingMaterialContent/listByTeachingMaterialId/" + this.form1.teachingMaterialId, (data) => {
                this.options1 = data.result;
            })
        },
        closeSharing() {
            this.showSharing = false;
            this.loadLessons();
        },
        loadFuncs() {
            this.$ajaxPost("/knowledge/knowledgeByTask", {form: this.taskForm}, (data) => {//knowledgeTree
                this.options2 = data.result;
            })
        }
    },
    created() {
        this.loadLessons();
        this.loadTeachingMaterial();
    }

}
</script>
